// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import HydrantPagingResultModel from '../../model/hydrant-paging-result-model';
import HydrantPagingResultDTO from '../dto/hydrant-paging-result-dto';
import dtoSchema from '../schemas/hydrant-paging-result-schema';
import HydrantModel from '../../model/hydrant-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class HydrantPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<HydrantPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => HydrantModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: HydrantModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<HydrantPagingResultDTO>): HydrantPagingResultModel;
  static toModel(dto: DeepPartial<HydrantPagingResultDTO> | undefined | null): HydrantPagingResultModel | undefined;
  static toModel(dto: DeepPartial<HydrantPagingResultDTO> | undefined | null): HydrantPagingResultModel | undefined {
    return dto ? new HydrantPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<HydrantPagingResultModel> | HydrantPagingResultModel): HydrantPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as HydrantPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for HydrantPagingResultModel, can not map to HydrantPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
